import React from 'react';
import { NO_TEAM_string } from '../../../../../general/model';
import { FileManagerRow } from '../../model';

export const Inner: React.FC<{
  cellData: any;
  rowData: FileManagerRow;
}> = ({ rowData }) => {
  const team = rowData.creative?.team?.name ?? NO_TEAM_string;
  return <span title={team}>{team}</span>;
};

export const TeamCell = (props: any) => <Inner {...props} />;
